module.exports = __webpack_public_path__ + "img/Overview-small.a94c1b0c.png";